import "@css/Loader.css";
import PropTypes from "prop-types";

/**
 * BodyLoader - компонент загрузки для контентной области (без меню)
 * Используется внутри страниц для отображения загрузки данных
 * @param {string} text - Текст загрузки (по умолчанию: "Загрузка...")
 * @param {boolean} overlay - Поверх содержимого родителя (родитель с position: relative),
 *   например поверх доски, пока компьютер думает
 * @param {boolean} inline - Маленький, в строку с текстом (например, внутри формы)
 */
const BodyLoader = ({ text = "Загрузка...", overlay = false, inline = false }) => {
    const className = [
        "body-loader",
        overlay ? "body-loader--overlay" : "",
        inline ? "body-loader--inline" : "",
    ].filter(Boolean).join(" ");

    return (
        <output className={className} aria-live="polite">
            <span className="loader-spinner" />
            <span className="loader-text">{text}</span>
        </output>
    );
};

BodyLoader.propTypes = {
    text: PropTypes.string,
    overlay: PropTypes.bool,
    inline: PropTypes.bool,
};

export default BodyLoader;
